function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17 2a1 1 0 10-2 0v13a1 1 0 102 0V2z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.307 6.579a1 1 0 00-.614-1.904C6.069 6.492 2 11.77 2 18c0 7.732 6.268 14 14 14s14-6.268 14-14c0-6.23-4.07-11.508-9.693-13.325a1 1 0 00-.614 1.904C24.514 8.136 28 12.662 28 18c0 6.627-5.373 12-12 12S4 24.627 4 18c0-5.338 3.486-9.864 8.307-11.421z",
  fill: "currentColor"
})));